import * as React from 'react';
import { Provider } from 'react-redux';
import store, { browserHistory, persistor } from './store/store';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles/';
import { PersistGate } from 'redux-persist/integration/react';
import Firebase, { FirebaseContext } from './Auth/components/Firebase';
import { Route, Redirect, RouteProps, Switch } from "react-router-dom";
import { ConnectedRouter } from 'connected-react-router'
import { Container } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import theme from './QmoTheme'
import HomeView from './views/HomeView'
import LoginView from './views/LoginView'
import OrderView from './views/OrderView'
import HistoricalOrdersView from './views/HistoricalOrdersView'
import AccountDetailsView from './views/AccountDetailsView'
import SearchView from './views/SearchView'
import SignUpView from './views/SignUpView'
import ResetPasswordView from './views/ResetPasswordView'
import MasterLayoutCnn from './Layout/connected/MasterLayoutCnn';
import FirebaseActionView from './views/FirebaseActionView';
import NotFoundView from './views/Common/NotFoundView';
import { LocalStorageWrapper } from './LocalStorage/LocalStorageWrapper';
import RegisterSupplierInPaymentServiceView from './views/Supplier/RegisterSupplierInPaymentServiceView';
import { stripePublishKey } from './Common/QmoConfiguration';

interface Props extends RouteProps {
  component: new (props: any) => React.Component,
}

function PrivateRoute({ component: Component, ...rest }: Props) {

  return (
    <Route
      {...rest}
      render={(props) => {
        return !!LocalStorageWrapper.Get("id_token")
          ? <Component {...props} />
          : <Redirect to={{ pathname: '/Login', state: { from: props.location } }} />
      }
      }
    />
  )
}

const stripePromise = loadStripe(stripePublishKey)

const App: React.FC = () => {
  return (
    <FirebaseContext.Provider value={new Firebase()}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Elements stripe={stripePromise}>
            <CssBaseline />
            <MuiThemeProvider theme={theme}>

              <Container>
                <ConnectedRouter history={browserHistory}>
                  <MasterLayoutCnn>
                    <Switch>
                      <PrivateRoute exact={true} path="/" component={HomeView} />
                      <PrivateRoute exact={true} path="/Search" component={SearchView} />
                      {/* <PrivateRoute path="/Intro" component={IntroView} /> */}
                      <PrivateRoute exact={true} path="/Order" component={OrderView} />
                      <PrivateRoute exact={true} path="/HistoricalOrders" component={HistoricalOrdersView} />
                      <PrivateRoute exact={true} path="/Account/" component={AccountDetailsView} />
                      <PrivateRoute exact={true} path="/Account/RegisterPaymentAccount" component={RegisterSupplierInPaymentServiceView} />

                      <Route path='/Login' component={LoginView} />
                      <Route path='/SignUp' component={SignUpView} />
                      <Route path='/ResetPassword' component={ResetPasswordView} />
                      <Route path='/Action' component={FirebaseActionView} />
                      <Route path="*" component={NotFoundView} />
                    </Switch>
                  </MasterLayoutCnn>
                </ConnectedRouter>
              </Container>

            </MuiThemeProvider>
          </Elements>
        </PersistGate>
      </Provider>
    </FirebaseContext.Provider>
  );
}

export default App;
